import { useState, useEffect } from "react";
import { useData } from "../../Context/DataContext";
import { useAuth } from "../../Context/AuthContext";
import { useClaims } from "../../Context/ClaimsContext";
import ButtonComponent from "../Inputs/ButtonComponent";
import FormInputComponent from "../Inputs/FormInputComponent";


const ClaimNotesForm = () => {
  const {allUsers} = useAuth();

  const {currentClaimsNotes, currentClaimId, storeClaimsNotes} = useClaims();

  const {currentUser} = useAuth();

  const [noteContent, setNoteContent] = useState("");
  const [submitCount, setSubmitCount] = useState(0)
  const [isLoading, setIsLoading] = useState(true);

  const handleSubmitNotes = () => {
    const data = {
      claim_id: currentClaimId,
      date: getCurrentDateString(),
      notes: noteContent,
      coordinator: currentUser.userId
    }
    storeClaimsNotes(data)

    setNoteContent("");
  }

  function getCurrentDateString(): string {
    const date = new Date();
  
    
    const year: number = date.getFullYear();
    let month: string = (date.getMonth() + 1).toString();
    let day: string = date.getDate().toString();
  

    month = month.length < 2 ? '0' + month : month;
    day = day.length < 2 ? '0' + day : day;
  

    return `${year}-${month}-${day}`;
  }

  function reformatDateString(date: string): string {
    if (!date) return "N/A";
  
    // Create a new Date object from the input string
    const dateString = new Date(date);
  
    // Extract the year, month, and day
    const year = dateString.getUTCFullYear();
    let month = (dateString.getUTCMonth() + 1).toString();
    let day = dateString.getUTCDate().toString();
  
    // Format month and day to ensure two digits
    month = month.length < 2 ? '0' + month : month;
    day = day.length < 2 ? '0' + day : day;
  
    return `${year}-${month}-${day}`;
  }


  const getCoordinatorName = (coordinatorId: string) => {
    if (allUsers) {
      const user = allUsers.find((user) => user.userid === coordinatorId);
      return user ? user.name : "N/A"
    }
    return 'N/A'
  };


  return (
    <div className="w-full">
      <table className="min-w-full divide-y divide-primary rounded-lg overflow-hidden">
        <thead className="bg-dark-card border-b border-dark-border min-w-full">
          <tr>
            <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              Date
            </th>
            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              Notes
            </th>
            <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              Name
            </th>
          </tr>
        </thead>
        <tbody className="bg-dark-bg divide-y divide-dark-border">
          {currentClaimsNotes && currentClaimsNotes.map((note, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-white">
                {reformatDateString(note.date) || "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-wrap text-sm text-white ">
                {note.notes || "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-wrap text-sm text-white">
                {getCoordinatorName(note.coordinator) || "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <form>
        <div className='flex my-2 px-3 py-2 flex-col justify-center rounded-lg'>
        <p className="font-semibold text-accent-teal text-md mr-4 mb-1">Enter New Note</p>
        <input
          className="flex-1 text-base border border-dark-border bg-dark-input text-white placeholder-gray-500 rounded-xl px-3 py-2 focus:outline-none focus:border-accent-teal"
          value={noteContent}
          onChange={(e) => setNoteContent(e.target.value)}
          placeholder="Add new note..."
        />
        </div>
        <div className="mb-5">
        <ButtonComponent label="Submit Notes" handler={handleSubmitNotes}/>
        </div>
      </form>
    </div>
  )
}

export default ClaimNotesForm